module.exports = __webpack_public_path__ + "715b6da0fe1162770be5e4b25786fa42.svg";